import { AdjustmentInventoryType } from "../validations"

export const validateAdjusmentDetail = (data: AdjustmentInventoryType) => {
    const errors: Record<string, string> = {}
  
    data.adjusmentDetail.forEach((item, index) => {
        const stockIn = Number(item.stock_in ?? 0)
        const stockOut = Number(item.stock_out ?? 0)
      
        if (stockIn <= 0 && stockOut <= 0) {
          errors[`adjusmentDetail.${index}.stock_in`] = 'Stock in better than 0'
          errors[`adjusmentDetail.${index}.stock_out`] = 'Stock out better than 0'
        }
      })
  
    return errors
  }
  